import React from 'react'
import '../App.css'
import Bodyhome from './bodyhome'
export class Bodyapphomebody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodyhome />
            </div>
        );
    }
}